import React from "react";
import { getDisclosureStatusDisplay } from "./vendorStatusUtils";

/**
 * @param {object} props
 * @param {string} [props.status]
 * @param {'header' | 'inline'} [props.variant] — header: larger pill; inline: compact for lists
 */
export default function VendorStatusBadge({ status, variant = "header" }) {
  const c = getDisclosureStatusDisplay(status);
  const isHeader = variant === "header";

  return (
    <span
      className={
        isHeader
          ? `badge rounded-pill px-3 py-2 d-inline-flex align-items-center gap-2 shadow-sm ${c.badgeClass}`
          : `badge rounded-pill px-2 py-1 small fw-semibold d-inline-flex align-items-center gap-1 text-nowrap border ${c.badgeClass} ${c.borderClass || ""}`
      }
      title={`Status: ${c.label}`}
    >
      <i className={`bi ${c.icon}`} aria-hidden="true" />
      <span>{c.label}</span>
    </span>
  );
}
